import { render, staticRenderFns } from "./EditFicha.vue?vue&type=template&id=6922c92d"
import script from "./EditFicha.vue?vue&type=script&lang=js"
export * from "./EditFicha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports